<template>
  <div>
    <el-dialog v-bind='$attrs' v-on='$listeners' @open='onOpen' @close='onClose' :title='dialogTitle'
               width='80%'>

      <el-row :gutter='15'>
        <el-col :span='12'>
          <el-upload
            class='upload-demo'
            :on-change='handleChange'
            :on-success='importSuccess'
            :headers='uploadHeaders'
            :data='postData'
            name='file'
            :show-file-list='false'
            :file-list='file'
            :before-upload='beforeUpload'
            drag
            action='/admin_api/artist_pic_text_record/import'
            multiple>
            <i class='el-icon-upload'></i>
            <div class='el-upload__text'>将文件拖到此处，或<em>点击上传</em></div>
            <div class='el-upload__tip' slot='tip'></div>
          </el-upload>
        </el-col>
        <el-col :span='12'>
          <div>
            <export-btn :can-export='true' ref='refExportLink' type='primary' lintTitle='下载导入模板'
                        @export='downloadTpl'></export-btn>
          </div>
          <div>
            <tips :data='tipList'></tips>
          </div>

        </el-col>
      </el-row>
      <el-row>
        <el-col :span='24'>
          <div class='default-table'>
            <el-divider>导入数据预览</el-divider>
            <el-table :data='dataForm' max-height='500' border>
              <el-table-column label='序号' type='index' header-align="center" align='center' width='80' />
              <el-table-column label='部门—组' prop='dept_nm' header-align="center" align='center' width='120' />
              <el-table-column label='红人昵称' prop='nickname' header-align="center" align='center' width='120' />
              <el-table-column label='红人ID' prop='artist_id' header-align="center" align='center' width='150' />
              <el-table-column label='编辑' prop='editor' header-align="center" align='center' width='120' />
              <el-table-column label='更新日期' prop='upd_at' header-align="center" align='center' width='150' />
              <el-table-column label='内容主题' prop='theme' header-align="center" align='center' min-width='150' />
              <el-table-column label='点赞' prop='zan_num' header-align="center" align='right' width='80' />
              <el-table-column label='评论' prop='comment_num' header-align="center" align='right' width='80' />
              <el-table-column label='收藏' prop='collect_num' header-align="center" align='right' width='80' />
              <el-table-column label='浏览量' prop='browse_num' header-align="center" align='right' width='80' />
              <el-table-column label='投放花费' prop='invest_num' header-align="center" align='right' width='100' />
              <el-table-column label='维护花费' prop='maintenance_num' header-align="center" align='right' width='100' />
              <el-table-column label='累计更新' prop='upd_num' header-align="center" align='right' width='80' />
            </el-table>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import ExportBtn from '@/components/export/ExportBtn'
import { getToken } from '@/utils/auth'

export default {
  name: 'ImportArtistPicTextRecord',
  components: { ExportBtn },
  props: {
    id: {
      type: [Number, String]
    }
  },
  data() {
    return {
      dialogTitle: '导入图文数据',
      file: [],
      uploadLoading: false,
      uploadHeaders: { 'HYPERF-SESSION-ID': null },
      postData: { lb_id: null },
      maxSize: 10,//文件最大的 5 M
      tipList: [
        '第1步，下载模板',
        '第2步，按照模板规范填好数据后，根据提示上传文件',
        '注意：1）二次导入，将会追加数据 2）表格空行会过滤'
        // '第3步，预览导入的数据，确认无误后，点击“提交”按钮'
      ],
      dataForm: []
    }
  },
  methods: {
    onOpen() {
      this.dataForm = []
    },
    onClose() {},
    close() {
      this.$emit('update:visible', false)
    },
    showDemo() {
      this.demandList = [{
        category_name: '美妆—护肤',
        demand: '秋冬保湿补水面霜',
        // price_first: '100-200',
        // num_first: '5',
        // price_second: '200-500',
        // num_second: '3',
        // price_third: '500-1000',
        // num_third: '2',
        title: '1.绽妍  2.颐莲 3.PMPM',
        remark: '请写清楚具体产品及价格范围'
      }]
    },
    async downloadTpl() {
      try {
        const name = `红人图文数据导入模板`
        this.$notify.info(name)
        const response = await this.$api.artistPicTextRecordExportList({is_export: 0})
        this.$refs.refExportLink.exportSaveXlsx(response, name)
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
      }
    },
    // ======================= 导入相关 =====================
    handleChange(file) {
      this.file = [file]
    },
    beforeUpload(file) {
      //身份凭据
      this.uploadHeaders['HYPERF-SESSION-ID'] = getToken()

      this.uploadLoading = true
      const isLt2M = file.size / 1024 / 1024 < this.maxSize
      if (!isLt2M) {
        this.$message.error(`导入文件大小不能超过 ${this.maxSize}MB!`)
        this.uploadLoading = false
      }
      return isLt2M
    },
    importSuccess(response) {
      if (response.code === 200) {
        this.$notify.success('导入成功')
        const { data: { list } } = response
        // console.log(list)
        this.dataForm = list
        this.$emit('imported')
        // setTimeout(() => {
        //   this.close()
        // }, 500)
      } else {
        this.$message.warning(response.msg || '导入失败')
      }
    }
  }
}
</script>

<style scoped>

</style>
